<template>
  <layout page="student-list">
    <page-title icon="lni lni-users" :breadcrumb="breadcrumb">Alunos</page-title>
    <div class="card table">
      <header class="card-header">
        <p class="card-header-title">
          <span>Alunos</span>
        </p>
        <div class="card-header-icon" aria-label="novo aluno">
          <button class="button is-success mr-2" @click="$refs.inputImport.click()">
            <i class="lni lni-arrow-up mr-1"></i>
            Importar
          </button>
          <input style="display: none" type="file" ref="inputImport" @change="importFile" accept=".csv" />
          <router-link class="button is-primary" :to="b.path">
            <i class="lni lni-plus mr-1"></i> <span>Novo Aluno</span>
          </router-link>
        </div>
      </header>
      <div class="card-content">
        <div v-if="students.length > 0" class="table-container">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Matrícula</th>
                <th>Nome</th>
                <th>Email</th>
                <th>Idade</th>
                <td>Ações</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, index) in students" :key="student.id">
                <td>{{ student.enrollment }}</td>
                <td>{{ student.name }}</td>
                <td>{{ student.email }}</td>
                <td>{{ student.age }}</td>
                <td>
                  <router-link class="button is-primary is-small mr-1" :to="`/admin/alunos/${student.id}/editar`" title="Editar Aluno">
                    <i class="lni lni-pencil-alt"></i>
                  </router-link>
                  <button class="button is-danger is-small" title="Excluir Aluno" @click="excluir(index, student.id, student.name)">
                    <i class="lni lni-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <empty-list v-else entity="alunos" />
      </div>
    </div>
  </layout>
</template>

<script>
import api from '@/api'
import Swal from 'sweetalert2'
import { DASHBOARD, STUDENT_LIST, STUDENT_FORM } from '@/config/breadcrumb/admin'
import Layout from '@/layout/admin/Layout'
import PageTitle from '@/components/admin/PageTitle'
import EmptyList from '@/components/ui/EmptyList'

export default {
  name: 'StudentList',
  components: {
    Layout,
    PageTitle,
    EmptyList
  },
  created () {
    api.get('/students').then(res => {
      this.students = res.data
    })
  },
  data () {
    return {
      students: []
    }
  },
  computed: {
    breadcrumb () {
      return [DASHBOARD, { ...STUDENT_LIST, isActive: true }]
    },
    b () {
      return STUDENT_FORM
    }
  },
  methods: {
    excluir (index, id, name) {
      Swal.fire({
        title: 'Tem certeza?',
        text: `Você tem certeza que deseja excluir o aluno: ${name}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          api.delete(`/students/${id}`).then(res => {
            if (res.status === 200) {
              this.students.splice(index, 1)
            }
          })
        }
      })
    },
    importFile () {
    }
  }
}
</script>
